const initialState = {
	merchandise: null
}

export const MerchandiseReducer = (state = initialState, { type, payload = {} }) => {
	switch (type) {
		case 'MERCHANDISE': {
			// console.log({
			// 	reducer: {
			// 		type: type,
			// 		payload: payload.data
			// 	}
			// })
			return {
				...state,
				merchandise: { ...payload.data.data }
			}
		}
		default: return state
	}
}